import get from 'lodash/get';
import { getAppLabOrg } from '~lib/common/config/appLabOrg';

function isPublished(caseConf) {
  return (
    (get(caseConf, 'access.read.groups') || []).includes('ALL_ADMINS') ||
    (get(caseConf, 'access.run.groups') || []).includes('ALL_ADMINS')
  );
}

function hasAppLabAccess(caseConf, productType) {
  return (
    (get(caseConf, 'access.read.groups') || []).includes(getAppLabOrg(productType)) ||
    (get(caseConf, 'access.run.groups') || []).includes(getAppLabOrg(productType))
  );
}

export {
  isPublished,
  hasAppLabAccess
};